import { render, staticRenderFns } from "./LeavePageApplicationTable.vue?vue&type=template&id=46a410d0&scoped=true&"
import script from "./LeavePageApplicationTable.vue?vue&type=script&lang=js&"
export * from "./LeavePageApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a410d0",
  null
  
)

export default component.exports